// Site constants
export const SITE_NAME = 'CGS';
export const SITE_FULL_NAME = 'The Church Gathered and Scattered';
export const SITE_TAGLINE = 'A Reformed Presbyterian Church';

export const CONTACT_INFO = {
  name: 'The Church Gathered and Scattered',
  address: '125 Galway Pl., 2nd Floor',
  city: 'Teaneck',
  state: 'NJ',
  zip: '07666',
  phone: '(201) 530-5888',
  email: 'info@cgsnj.org',
};

export const SERVICE_TIMES = {
  saturday: {
    name: 'Saturday Prayer',
    time: '8:00 AM',
  },
  sunday: {
    name: 'Sunday Worship',
    time: '10:00 AM',
  },
};

export const SOCIAL_LINKS = {
  facebook: 'https://facebook.com/cgsnj',
  instagram: 'https://instagram.com/cgsnj',
  youtube: 'https://youtube.com/@thechurchgatheredandscatte6166/streams',
};

// Navigation structure
export const NAV_LINKS = [
  {
    label: 'About',
    href: '/about',
    children: [
      { label: 'Our Story', href: '/about' },
      { label: 'Beliefs', href: '/about/beliefs' },
      { label: 'Leadership', href: '/about/leadership' },
    ],
  },
  {
    label: 'Worship',
    href: '/worship',
    children: [
      { label: 'Livestream', href: '/livestream' },
      { label: 'Sermons', href: '/sermons' },
      { label: 'Sunday Bulletin', href: '/bulletin' },
    ],
  },
  {
    label: 'Connect',
    href: '/connect',
    children: [
      { label: 'Small Groups', href: '/small-groups' },
      { label: 'Events', href: '/events' },
      { label: 'Contact', href: '/contact' },
    ],
  },
  {
    label: 'Podcast',
    href: '/podcast',
  },
  {
    label: 'Blog',
    href: '/blog',
  },
];

// Color palette for reference
export const COLORS = {
  primary: '#072441',
  accent: '#FFE658',
  white: '#FFFFFF',
  black: '#000000',
  highlight: '#D8EAF8',
  neutral: '#E7E4DC',
};

// Animation variants for Framer Motion
export const FADE_IN = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export const SLIDE_UP = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -30 },
};

export const SLIDE_DOWN = {
  initial: { opacity: 0, y: -30 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 30 },
};

export const STAGGER_CONTAINER = {
  animate: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};
